import { connectHits } from 'instantsearch.js/es/connectors';

const renderHits = (renderOptions, isFirstRender) => {
    const { hits, widgetParams, results } = renderOptions;
    let themePath = $('.tematik_produits').data('theme-path');
    let defaultImg = themePath + '/img/photos/default-img.svg';
    let baseUrl = $('.tematik_produits').data('url');
    let ficheProduitUrl = $('.tematik_produits').data('fiche-produit-url');
    let phraseAjoutPanier = $('.tematik_produits').data('ajout-panier');
    let phraseTelechargerProduit = $('.tematik_produits').data('telecharger-media');
    let phraseTelechargerEtiquette = $('.tematik_produits').data('telecharger-etiquette');
    let phraseTelechargerFicheTechnique = $('.tematik_produits').data('telecharger-fiche-technique');
    let produitTrad = $('.tematik_produits').data('produit');
    // Cette liste permettra de savoir si le produit a un fiche produit ou pas
    let listeFicheTechnique = $('.tematik_produits').data('list-fiche-technique');
    // Cette liste permettra de savoir si le produit a une étiquette ou pas
    let listeEtiquette = $('.tematik_produits').data('list-etiquette');
    let langue = $('.tematik_produits').data('langue');
    // FIXME: i18n
    widgetParams.container.innerHTML = `
        ${hits
            .map(
                (item) => `
            <li class="ais-InfiniteHits-item">
                <div class="donnees-item">
                <div class="donnees-images-container">
                <figure
                    class="donnees-image"
                    style="background-image: url(${themePath}/img/gravures/gravure-bg-produit.png);"
                >
                ${(item.illustration_principale) ? `
                    <picture>
                        ${(item.illustration_principale) ? `
                            <source srcset="${baseUrl + item.illustration_principale.webp}" type="image/webp">
                        ` : ''}
                        <img src="${baseUrl + item.illustration_principale.base}" alt="${item.nom_produit}">    
                    </picture>
                ` : `
                    <img src="${defaultImg}" alt="${item.nom_produit}"></img>
                `}
                </figure>
                ${item.illustrations_logo ? 
                    `<figure class="donnees-label">
                        ${item.illustrations_logo ? item.illustrations_logo.map(logo => 
                            `<img src="${baseUrl + logo.path}" alt="${logo.nom}">`
                            ).join('') : ""}
                     </figure>`
                : ""}
                </div>
                <div class="donnees-contenu">
                    <h5 class="titre5--lowercase">${item.nom_produit}</h5>
                    <span class="tag"><strong>${item.marque}</strong></span>
                    <span class="tag text-black typeProduit"><i class="icon-tag"></i>${
                        item.gamme_produit
                    }</span>
                    ${item.description_pro ? 
                        `<p>${item.description_pro.substring(0, 175)}${
                            item.description_pro.length > 175 ? '...' : ''
                        }</p>`
                    : `<p>${item.description.substring(0, 175)}${
                        item.description.length > 175 ? '...' : ''
                    }</p>`}
                </div>
                <div class="donnees-caracteristiques">
                    <ul class="donnees-attributs">
                        <li><i class="icon-weight"></i>${item.conditionnement}${
                    item.unite_conditionnement
                }</li>
                        <li>
                            <i class="icon-barcode"></i>
                            <strong class="text-secondary">${produitTrad}</strong>
                            ${item.code_article ? item.code_article.toUpperCase() : item.code_article_uvc.toUpperCase()}
                        </li>
                        ${item.gencode ? 
                        `<li>
                            <i class="icon-barcode"></i>
                            <strong class="text-secondary">EAN</strong>
                            ${item.gencode ? item.gencode : ""}
                        </li>` : ""}
                    </ul>
                    <a
                        class="lienTous lienTous--primary panier"
                        role="button"
                        tabindex="0"
                        data-id="${item.gencode ? item.gencode : ""}"
                        data-container=".ccm-page"
                        data-toggle="popover"
                        data-placement="bottom"
                    >
                        <span class="lienPlus">${phraseAjoutPanier}</span>
                        <span class="bto bto-sm"><i class="icon-notepad"></i></span>
                    </a>
                    <a
                        class="lienTous lienTous--tertiary zip"
                        role="button"
                        data-id="${item.id}"
                        data-container=".ccm-page"
                        data-toggle="popover"
                        data-placement="bottom"
                    >
                        <span class="lienPlus">${phraseTelechargerProduit}</span>
                        <span class="bto bto-sm"><i class="icon-download"></i></span>
                    </a>
                    ${ listeFicheTechnique.includes(item.gencode + "_" + (item.code_article_uvc ? item.code_article_uvc.toUpperCase() : 'NC') + "_" + (item.code_article ? item.code_article.toUpperCase() : 'NC') + "_Modele-FT-" + langue.toUpperCase() + ".pdf") ? `    
                    <a
                        class="lienTous lienTous--quaternary fiche"
                        role="button"
                        data-id="${item.id}"
                        data-container=".ccm-page"
                        data-toggle="popover"
                        data-placement="bottom"
                        data-gencode="${item.gencode}"
                        data-code="${item.code_article ? item.code_article : "NC" }"
                        data-code-uvc="${item.code_article_uvc ? item.code_article_uvc : "NC" }"
                    >
                        <span class="lienPlus">${phraseTelechargerFicheTechnique}</span>
                        <span class="bto bto-sm"><i class="icon-file"></i></span>
                    </a>` : "" }

                    ${ listeEtiquette.includes(item.gencode + "_" + (item.code_article_uvc ? item.code_article_uvc.toUpperCase() : 'NC') + "_" + (item.code_article ? item.code_article.toUpperCase() : 'NC') + "_Modele-FT-" + langue.toUpperCase() + ".pdf") ? `    
                    <a
                        class="lienTous lienTous--quaternary etiquette"
                        role="button"
                        data-id="${item.id}"
                        data-container=".ccm-page"
                        data-toggle="popover"
                        data-placement="bottom"
                        data-gencode="${item.gencode}"
                        data-code="${item.code_article ? item.code_article : "NC" }"
                        data-code-uvc="${item.code_article_uvc ? item.code_article_uvc : "NC" }"
                    >
                        <span class="lienPlus">${phraseTelechargerEtiquette}</span>
                        <span class="bto bto-sm"><i class="icon-file"></i></span>
                    </a>` : "" }

                    
                </div>
            </li>`
            )
            .join('')}`;
};

const customHits = connectHits(renderHits);

export default customHits;
